<div class="scp-container">
    <p class="title">{{title}}</p>
    <form [formGroup]="form" class="scp-form">

        <div class="scp-group">
            <label class="primaryColor">Cliente</label>
            <select formControlName="customerId" class="form-control">
                <option class="ligthColor" value=null>Seleccione un cliente</option>
                <option *ngFor="let l of customerList" value="{{l.customerId}}">{{l.customer}}</option>
            </select>
            <div class="invalid-text" *ngIf="form.get('customerId').invalid && form.get('customerId').touched">Seleccione una opcion valida</div>
        </div>

        <div class="scp-group">
            <label class="primaryColor">Nombre</label>
            <input name="name" formControlName="name" class="form-control" placeholder="Nombre">
            <div class="invalid-text" *ngIf="form.get('name').invalid && form.get('name').touched">Ingrese un nombre valido</div>
        </div>
     
        <div *ngIf="auditPreviousId != 0" class="scp-group-checkbox">
            <label class="primaryColor">Activo</label>
            <div class="scp-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                <div class="scp-checkbox">
                    <input id="check" formControlName="active" type="checkbox">
                    <label class="scp-label" for="check">
                        <mat-icon>done</mat-icon>
                    </label>
                </div>
            </div>
        </div>

        <div class="scp-group">
            <label class="primaryColor">Guardar</label>
            <div class="scp-container-button">
                <button type="reset" class="scp-button" mat-raised-button matTooltip="Guardar" mat-raised-button [disabled]="!form.valid" matTooltipPosition="right" matTooltipClass="tooltip" (click)="save()">
                    <mat-icon>save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>